export default __webpack_public_path__ + "media/aa327cb5a8a01dacecce01e8887ac9c94af18747265a737896d2e4a14b432068.svg";